/**
 * Sesión Firebase para la PÁGINA PÚBLICA de atleta (ruta /atleta, sin
 * LoginGate). Los atletas no tienen cuenta ni pasan por la whitelist, pero
 * /api/events y /api/campeonatos exigen un ID token válido (backend
 * `_authorize_public`, que acepta anónimos). Solución: entrar de forma
 * ANÓNIMA (signInAnonymously) de forma transparente — el atleta no ve login.
 *
 * REQUISITO DE CONSOLA: hay que habilitar el proveedor "Anónimo" en Firebase
 * Console → Authentication → Sign-in method. Sin eso, signInAnonymously
 * devuelve auth/operation-not-allowed.
 */
import { signInAnonymously } from 'firebase/auth';
import { auth } from '@/lib/firebase';

let _pending: Promise<void> | null = null;

/** Garantiza que hay un `auth.currentUser` (aunque sea anónimo) antes de
 *  llamar a la API. Idempotente y a prueba de llamadas concurrentes. */
export async function ensureAnonAuth(): Promise<void> {
  if (auth.currentUser) return;
  if (!_pending) {
    _pending = signInAnonymously(auth)
      .then(() => undefined)
      .finally(() => {
        _pending = null;
      });
  }
  return _pending;
}
